import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AirportsInt } from '@interfaces/';
import { AirportModel } from '@models/index';

@Injectable({
  providedIn: 'root'
})
export class AirportsService {
  airports: Array<AirportsInt> = [];
  constructor(private http: HttpClient) { }

  loadAirports( ): Observable<Array<AirportModel>> {
    return this.http.get<AirportModel[]>('../../assets/data/resources/airportList.json', {})
    .pipe(
      map (( res ) => res.map((data)=> new AirportModel(data))
    ));
  }
}
